export const ColorCategoryPrefab = [
    {
        value: "#7AAFF9",
        text: <span><i className="fas fa-cube" style={{ color: "#7AAFF9" }}></i> </span>
    },
    {
        value: "#76E570",
        text: <span><i className="fas fa-cube" style={{ color: "#76E570" }}></i> </span>
    },

    {
        value: "#FFBD7C",
        text: <span><i className="fas fa-cube" style={{ color: "#FFBD7C" }}></i> </span>
    },

    {
        value: "#FFDC7C",
        text: <span><i className="fas fa-cube" style={{ color: "#FFDC7C" }}></i> </span>
    },

    {
        value: "#F77D79",
        text: <span><i className="fas fa-cube" style={{ color: "#F77D79" }}></i> </span>
    },

    {
        value: "#BC70E5",
        text: <span><i className="fas fa-cube" style={{ color: "#BC70E5" }}></i> </span>
    },
]


